import { useTranslation } from 'react-i18next';
import { CommentForm } from 'components/comments/comment-form';
import { CommentsList } from 'components/comments/comments-list';
import { CardUi } from 'components/common/card-ui';
import type { ICommentsCardProps } from './types';

export const CommentsCard = (props: ICommentsCardProps) => {
  const { entityName, entityId } = props;
  const { t } = useTranslation();

  return (
    <CardUi title={t('comment:comments')}>
      <CommentForm entityName={entityName} entityId={entityId} />
      <CommentsList entityName={entityName} entityId={entityId} />
    </CardUi>
  );
};
